const configApp = {
  academyDomain: 'https://academia.vidroop.com',
  apiKeyTinyMce: 'nmmuxa1oi0rlug1hougubvrgge2hhd73ju9jq5thrlvy62gi',
  apiUrl: 'https://api.vidroop.com',
  apiVersion: 'v1',
  appDomain: 'https://aula.vidroop.com',
  authCallbackUrl: 'https://aula.vidroop.com/login',
  authClientId: 'CtSr3IPn2g678DK8rRBnaEQ02YAwiGMv',
  authDomain: 'vidroop.eu.auth0.com',
  pdfGeneratorDomain: 'https://pdfgenerator.vidroop.com/v1/invoice',
  stripePublicKey: 'pk_live_Qwsbmkvxlg25iLrzNW9qM4vi',
  marketPlaceDomain: 'https://tienda.vidroop.com/academia'
}

export default configApp